<script module lang="ts">
    import type { HTMLInputAttributes } from 'svelte/elements';
    export type Props = {
        label?: string | null;
        value?: string | null;
        error?: string | null;
        description?: string | null;
    } & HTMLInputAttributes;
</script>

<script lang="ts">
    import { Input } from '@/components/ui/input/index.js';
    import InputError from '@/components/InputError.svelte';
    import { Label } from '@/components/ui/label/index.js';
    import FieldDescription from './FieldDescription.svelte';
    import Debug from '@/components/Debug.svelte';

    let { label, value = $bindable(), error, description, ...args }: Props = $props();
</script>

<div class="flex flex-col gap-2">
    {#if label}
        <Label for={label}>
            {label}{#if args.required === true}<span class="ml-1 text-red-500">*</span>{/if}
        </Label>
    {/if}
    {#if description}
        <FieldDescription>{description}</FieldDescription>
    {/if}
    <Input id={label} class="block w-full" bind:value autocomplete="name" {...args} />
    {#if error}
        <InputError message={error} />
    {/if}
</div>
